import { Paged } from "../common/paged"

export class NotificationFilters extends Paged {
	constructor() {
		super();
	}
}